import React from 'react';
import { SectionCTA } from '../SectionCTA';
import { AUTHOR_PHOTO_URL } from '../../data/content';
export function Author() {
  return <section className="w-full bg-navy-900 px-4 py-14 text-white sm:py-20" aria-labelledby="author-title" data-id="element-80" data-mp="1htc1ov64itax">
      <div className="mx-auto grid max-w-5xl items-center gap-8 md:grid-cols-[minmax(0,2fr)_minmax(0,3fr)] md:gap-12" data-id="element-81" data-mp="1whzz76zj5d3i">
        <img src={AUTHOR_PHOTO_URL} alt="Michael Carter" className="mx-auto aspect-[4/5] w-full max-w-sm rounded-3xl object-cover ring-4 ring-gold-400" data-id="element-82" data-mp="1ro44cdekc6ck" />
        <div className="text-center md:text-left" data-id="element-83" data-mp="20kmrta40z21r">
          <p className="text-sm font-bold uppercase tracking-wide text-gold-400" data-id="element-84" data-mp="2fehxk78vwb8q">Meet your author</p>
          <h2 id="author-title" className="mt-2 font-display text-4xl font-black uppercase sm:text-5xl" data-id="element-85" data-mp="2ahhr3v84h6h3">
            Michael Carter
          </h2>
          <p className="mt-2 font-semibold text-accent-400" data-id="element-86" data-mp="l3cvv8hcy8w1">Aesthetic Laser Clinical Education</p>
          <div className="mt-6 space-y-4 text-base leading-relaxed text-white/80 sm:text-lg" data-id="element-87" data-mp="g4rx7dhr7x9p">
            <p data-id="element-88" data-mp="3gcjgm1qspktl">
              Michael Carter is the established editorial author of{' '}
              <strong className="text-white" data-id="element-89" data-mp="3kdv9cg4yum60">Aesthetic Laser Clinical Blueprint™</strong>.
            </p>
            <p data-id="element-90" data-mp="3pcy519z23g1b">
              This companion resource focuses specifically on organizing post-laser complication assessments,
              documentation, professional communication, and escalation workflows.
            </p>
            <p data-id="element-91" data-mp="7yau9bev9q9v">The material is designed around practical clinical tools rather than broad theoretical instruction.</p>
          </div>
        </div>
      </div>
      <div className="mx-auto max-w-5xl" data-id="element-92" data-mp="c0xqrpmhfzde">
        <SectionCTA label="Get Michael's complete blueprint" dark data-id="element-93" data-mp="gyz8a649fqmr" />
      </div>
    </section>;
}